import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d00a4058"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-number-field" }
const _hoisted_2 = {
  key: 0,
  class: "number-field-description"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["name", "min"]

import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-number-field',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["number-field-title", [_unref(themingCssClass)('normal')]])
    }, _toDisplayString(_ctx.description.label), 3),
    (_ctx.description.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.description.description), 1))
      : _createCommentVNode("", true),
    (_ctx.description.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.description.ivalue), 1))
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 2,
          type: "number",
          step: "1",
          name: _ctx.description.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description.ivalue) = $event)),
          min: _ctx.description.min
        }, null, 8, _hoisted_4)), [
          [_vModelText, _ctx.description.ivalue]
        ])
  ]))
}
}

})